/* eslint-disable max-len */
import React, { useCallback, useContext } from 'react'
import TopHeader from '../../components/TopHeader'
import { Link ,useNavigate} from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useViewUserQuery, usersList } from '../../features/apiSlice'
import { convertEpochToDateFormat } from '../../CommonMethods/DateConversion'
import formatMobileNumber from '../../CommonMethods/FormatMobileNumber'
import OrganizationAssociatedTouser from './OrganizationTable'
import CustomOverLay from '../../components/CustomOverLay'
import GlobalContext from '../../components/Context/GloablContext'
import ErrorMessage from '../../components/ErrorMessage'
import InputBox from '../../components/InputBox'
import PhoneNumberValidator from '../../components/PhoneNumberInput'
import Emptyscreenwithouttitle from '../../components/Emptyscreenwithouttitle'
import Loader from '../../components/Loader'
import {motion} from 'framer-motion'
import OtpInputField from '../../components/OtpInput/index'
import { useOnClickOutside } from '../../CommonMethods/OutsideClick'
import { useRef,useState,useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { validateEmail } from '../../CommonMethods/EmailValidator'
import { dataService } from '../../services/data.services'
import { userService } from '../../services/user.services'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import { handleClear, handleSidebarAnimation } from '../../redux/commonSlice'
import { logout } from '../auth/authSlice'
import { handleRestrictKey, handleSystemConfig } from '../../redux/systemConfigSlice'
import MaskedEmailJS from '../../CommonMethods/MaskedEmailJS'
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import MaskedEmail from '../../CommonMethods/MaskedEmail'
import { getAuthItem } from '../../CommonMethods/authSession'

export default function Profile() {
    const auth=useSelector(state=>state?.auth)
    const userType = getAuthItem('user_type')
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [logoutLoading, setLogoutLoading] = useState(false);
    const {data,isFetching,status}=useViewUserQuery( {refetchOnMountOrArgChange: true})
    const date=convertEpochToDateFormat(data?.userDetails?.created_at,dateformat)

    const otpInputRef = useRef(null);
    // const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const countryCodeList=useSelector((state)=>state?.systemConfigData?.countryCodes)
    const [countryCodeVal,setCountryCodeVal]=useState('')
    const [countryCodeVal2,setCountryCodeVal2]=useState('')
    const country_code = useSelector(state => state?.systemConfigData?.globalVariables?.country_code)
    // const enforce_otp=useSelector(state=>state?.systemConfigData?.globalVariables?.enforce_otp_verification)
    let [enforce_otp,setEnforceOtp] = useState(false)
    const dispatch=useDispatch()
    const limitArr = [15, 30, 50, 100];
    const ref = useRef();
    const navigate = useNavigate()
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage,isSideBar,setToastWarnmessage,restrictKey ,fetchAndCacheHelpGuides } = useContext(GlobalContext)
    const [preferences, setPreference] = useState({
        "mobile_number" : "",
        "country_code": country_code && country_code.match(/\d+/)?.[0],
        "otp_preference_mode": "text",
        "email_address": ""
    })
    const [countryCodes, setCountryCodes] = useState([])
    const [otp, setOtp] = useState([0,0,0,0,0,0]);
    const [error, seterror] = useState(false);
    const [duration,setDuration]=useState('')
    const [timer, setTimer] = useState(parseInt(duration));
    const [loading, setloading] = useState(false);
    const [verifyOtpScreen, setVerifyOtpScreen] = useState(false);
    const [errorMsg,setErrorMsg]=useState("")
    const [deletePreferenceModal, setDeletePreferenceModal] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState({});
    const [emailError, setEmailError] = useState(false);
    const [verificationLoading, setVerificationLoading] = useState(false);
    const [logOutOpen, setLogOutOpen] = useState(false);
    const [showOtpLogoutPrompt, setShowOtpLogoutPrompt] = useState(false);
    const [preferenceLoader,setPreferenceLoader] = useState(false)
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [emptyScreen, setEmptyScreen] = useState(false);
    const [initialLoader, setInitialLoader] = useState(true);
    const [submitSelected,setSubmitSelected]=useState(false);
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({"mobile_number":true});
    const restrict = useSelector((state)=>state?.systemConfigData?.restrict)

    useEffect(()=>{
        setCountryCodeVal(`${(country_code ? country_code.match(/\d+/)?.[0] || "" : "")}`)
    },[country_code])

    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-profile');
        } else {
            setQueryParamsadmin('type=admin-profile');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const [preferenceList, setPreferenceList] = useState([]);
    const [hoverProperties,setHoverProperties] = useState({
        'hover':'',
        'hover_index':'',
        'index_to_display_modal':''
    })

    const handleOtpPreference = (val) => {
        setEmailError(false)
        setPhoneNumberError(false)
        // Check if email_address is not empty, if not, set it to an empty string
        const updatedEmail = preferences.email_address !== "" ? "" : preferences.email_address;
    
        // Check if mobile_number is not empty, if not, set it to an empty string
        const updatedMobileNumber = (val==="email"&&preferences.mobile_number !== "") ? "" : preferences.mobile_number;

        setPreference({
            ...preferences,
            "otp_preference_mode": val,
            "email_address": updatedEmail,
            "mobile_number": updatedMobileNumber
        });
    };

    const fetchCountryCodes = async () => {
        const res = await userService.getCountryCodes();
        // const extractedValues = res.data.map((country) => country.callingCodes[0]+' '+'-'+' '+'('+country.name+')');
        let uniqueValues = [...new Set(res.data.map((country) => country.callingCodes[0]+' '+'-'+' '+'('+country.alpha3Code+')'))];
        setCountryCodes(uniqueValues)
    }
    const fetchSystemConfigData=useCallback(async()=>{
        // setLoading(true )
        let response
        response = await dataService.GetAPI(`system-configuration/`);
        if(response.error===false){
            dispatch(handleSystemConfig(response.data.data))
            setEnforceOtp(response?.data?.data?.enforce_otp_verification)
        }

    } ,[])

 

    useEffect(() => {
        setPreference((prev) => ({
            ...prev,
            country_code: `+ ${(country_code ? country_code.match(/\d+/)?.[0] || "" : "")}`
        }));
        fetchCountryCodes();
        fetchSystemConfigData();
        if(localStorage.getItem('arcm_trust_browser_token')){
            fetchAndCacheHelpGuides();
        }
    }, [])

    const handleUserInput = (id, value) => {
        setSubmitSelected(false)
        setEmailError(false)
        setPhoneNumberError(false)
        const isMobileNumber = id === "mobile_number";
        const sanitizedOption = isMobileNumber ? value.replace(/\D/g, "") : value;
        const isValid = isMobileNumber ? /^[1-9]\d*$/.test(sanitizedOption) : true;
        setPreference((prev) => ({
            ...prev,
            [id]: isValid ? value : sanitizedOption
        }));
        if (!isValid) {
            setEmailError(false);
        }
    };


    

    const handleCountryCode = (val) => {
        setPreference({
            ...preferences,
            "country_code": val
        })
    }
    const handleVerification = async () => {
        setVerificationLoading(true)
        setSubmitSelected(true)
        if(preferences.otp_preference_mode === 'email' && validateEmail(preferences?.email_address.trim())){
            setEmailError(true);
            setVerificationLoading(false)
            return
        }
        if ((preferences.otp_preference_mode === 'text' || preferences.otp_preference_mode === 'voice') && !(isPhoneNumberValid.mobile_number)) {
            setVerificationLoading(false)
            return;
        }
        const body = 
            {
                "country_code": preferences.otp_preference_mode === 'email' ? '' : (countryCodeVal === '' ? `+${country_code?.trim()}` : `+${countryCodeVal?.trim()}`),
                "preference": preferences.email_address === '' ? preferences.mobile_number : preferences.email_address.trim(),
                "otp_preference_mode": preferences.otp_preference_mode,
                "restrict": restrict
            }
        const response =  await userService.verifyPreference(body)
        if(response.error === false) {
            setVerifyOtpScreen(true)
            setVerificationLoading(false)
        } else if(response.error === true && response.message.response.status === 409) {
            setToastErrorMessage(response.message.response.data.message)
            setVerificationLoading(false)
        } 
        else if(response.error === true && response.message.response.status === 400) {
            setToastErrorMessage(response.message.response.data.message)
            setVerificationLoading(false)
        } else {
            setVerificationLoading(false)
            setToastErrorMessage('Something went wrong')
        }
            
    }

    const handleFetchPreferenceList = async () => {
        setPreferenceLoader(true)
        const response = await userService.preferenceList();
        if(response.error === false && response.data.data.length > 0) {
            setPreferenceList(response.data.data)
            setPreferenceLoader(false)
            setInitialLoader(false)
            setEmptyScreen(false)
        } else {
            setInitialLoader(false)
            setEmptyScreen(true)
            setPreferenceLoader(false)
        }   
    }
    
    useEffect(() => {
        setOtp(Array(6).fill(""))
        handleFetchPreferenceList()
        //handleFetchProfileDetails()
    }, [])
    

    const handleOTPVerification = async (e) => {
        e.preventDefault();
        setloading(true)
        const val = otp.toString().replace(/,/g, '')
        const body = {
            otp: val
        }
        const response = await userService.verifyOtp(body)
        if(response.error === false) {
            setToastmessage(response.data.message)
            handleFetchPreferenceList()
            setloading(false)
            setPreference({
                "mobile_number": "",
                "country_code": "",
                "otp_preference_mode": "text",
                "email_address": ""
            });
            setVerifyOtpScreen(false)
            setOtp(Array(6).fill(""))
            if (response?.data?.logout === true && (restrict === true || restrict === 'true')) {
                setShowOtpLogoutPrompt(true)
            }
        } else {
            setloading(false)
            setVerifyOtpScreen(true)
            if(response.message.response.data.message === "Invalid OTP entered 3 times, your preferences couldn't be saved. Please re-enter your preferences"){
                setToastWarnmessage(response.message.response.data.message)
                setOtp(Array(6).fill(""))
                setPreference({
                    "mobile_number": "",
                    "country_code": "",
                    "otp_preference_mode": "text",
                    "email_address": ""
                });
                setVerifyOtpScreen(false)
                
            } else {
                //setOtp(Array(6).fill(""))
                seterror(true)
                setErrorMsg(response.message.response.data.message)
                // setToastErrorMessage(response.message.response.data.message)
            }
        }
    };

    const handleLogout=async ()=>{
        setLogoutLoading(true)
        const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
        dispatch(handleClear())
        await userService.logout()
        dispatch(logout());
        localStorage.setItem('arcm_trust_browser_token', browserIdValue);
        dispatch(handleSidebarAnimation(true))
        localStorage.setItem('LogoutfromAllTabs','true')
        setToastmessage('Logout successful')  
        navigate('/')
        dispatch(usersList.util.resetApiState())
        setLogoutLoading(false)  
    }

    const openDeleteModal = async (item) => {

        // Read the setting directly so an admin toggle applies without a page refresh.
        // Not fetchSystemConfigData(): that also dispatches to Redux, which visibly
        // re-renders the profile. Falls back to the last known value if the request
        // fails, so the guard never silently disappears.
        const configResponse = await dataService.GetAPI(`system-configuration/`)
        const latestEnforceOtp = configResponse?.error === false
            ? configResponse?.data?.data?.enforce_otp_verification
            : enforce_otp

        if((latestEnforceOtp === true || latestEnforceOtp === 'true') && preferenceList.length===1){
            setToastErrorMessage('Atleast one preference is required')
        }
        else{
            setSelectedPreference(item)
            setDeletePreferenceModal(true)
        }
     
    }
    

    useOnClickOutside(ref, () => {
        setIsOpenLimit(false);
    });


    const handleDeletePreferences = async () => {
        setDeleteLoading(true)
        const isLastPreference = preferenceList.length === 1;
        try{
            const response = await userService.deletePreference(selectedPreference._id);
            if(response.error === false) {
                setDeleteLoading(false)
                setPreferenceLoader(false)
                setDeletePreferenceModal(false)
                setToastmessage('Mode of preference deleted successfully')
                handleFetchPreferenceList()
                // Only corporate-user is subject to navigation restriction; admins are exempt
                if (isLastPreference && userType === 'corporate-user') {
                    dispatch(handleRestrictKey(true))
                }
            }
        }catch(e){

            setDeleteLoading(false)
            setDeletePreferenceModal(false)
            setPreferenceLoader(false)
            setToastErrorMessage('Error while deleting mode of preference')
        }
        
    
    }
    const handleSelectCountryCode = (item) => {
        setPreference((prev) => ({
            ...prev,
            country_code: `+${parseInt(item.match(/\d+/)?.[0], 10)}`
        }));
        setCountryCodeVal(`+${parseInt(item.match(/\d+/)?.[0], 10)}`)
    }

   



    const handleCancel = () => {
        setVerifyOtpScreen(false)
        setPreference({
            "mobile_number": "",
            "country_code": country_code && country_code.match(/\d+/)?.[0],
            "otp_preference_mode": "text",
            "email_address": ""
        });
        handleFetchPreferenceList()
        setOtp(Array(6).fill(""))
    }

    useEffect(() => {
        if (otpInputRef.current) {
            otpInputRef.current.focus();
        }
    }, [otp]);

    return (
        <>
            {verifyOtpScreen&&userType!=='super-admin' ?
                <>
                    <TopHeader title={"Profile"}/>
                    <div className='flex flex-col justify-center items-center h-screen m-auto'>
                        <div className='w-full'>
                            <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>OTP Verification</h1>
                            <h1 className='text-lg font-normal text-[#777C88] text-center mb-[55px]'>
                                Enter the 6-digit OTP sent to {preferences.otp_preference_mode === 'email'
                                    ? <MaskedEmail value={preferences.email_address} />
                                    : `${countryCodeVal === ''
                                        ? `+${country_code} ${preferences.mobile_number?.slice(0, 2) +
                                        '*'.repeat(preferences?.mobile_number?.length - 4) +
                                        preferences?.mobile_number?.slice(-2)}`
                                        : `+${countryCodeVal} ${preferences.mobile_number?.slice(0, 2) +
                                        '*'.repeat(preferences?.mobile_number?.length - 4) +
                                        preferences?.mobile_number?.slice(-2)}`
                                    }`
                                }       
                            </h1>                     
                            <form onSubmit={(e)=>handleOTPVerification(e)}>
                                <div className="digit-group flex justify-center pt-1.5">
                                    <OtpInputField
                                        onChange={setOtp}
                                        inputs={otp}
                                        setInputs={setOtp}
                                        value={otp}
                                        inputType="tel"
                                        shouldAutoFocus	
                                        inputStyle="w-14 h-12 border-b-2 sm:mr-6 mr-5 border-[#A9B2BE] bg-[transparent] outline-0 text-center text-xs4 font-normal otp-input err-otp text-[#0D1B2A]"
                                        numInputs={6}
                                        error={error}
                                        seterror={seterror}
                                        renderInput={(props) => <input {...props} />}
                                        separator={<span></span>}
                                        
                                    />
                                </div>
                                {/* errormessage */}
                                {error &&<ErrorMessage error={error} message={errorMsg} classKey="text-xs font-normal text-[#C81720] mt-5 text-center" />}
                             
                                <div className='flex justify-center'> 
                                    <button type='submit'
                                        id="otp-form"
                                        disabled={otp.includes("")||loading||errorMsg==="Invalid session for the user."}
                                        className='w-[290px] mt-8 py-2 px-4 text-lg font-semibold text-[#fff] rounded-[16px] 
                            bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'>
                                        {!loading?' Verify OTP':<span>{<Loader/>}</span>}
                                    </button>
                                </div>
                                <div className='flex justify-center'>
                                    <button 
                                        className='w-[290px] px-2.5 py-2 border border-[#972E4C] h-fit rounded-[16px] text-center text-lg font-normal text-[#972E4C] m-auto mt-[30px] disabled:cursor-not-allowed'
                                        onClick={() => handleCancel()}
                                        disabled={loading}
                                    >{`I didn't receive the OTP`}</button></div>
                            </form>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full scrollbar_purple  overflow-x-hidden'>
                        <TopHeader title={`Profile`}/>
                        {isFetching&&status!=="fulfilled"?<CustomOverLay Active text="Loading Profile Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:<>

                            <div className='bg-white rounded-lg xl:px-[48px] px-7 h-customh3 overflow-x-auto scrollBar-hidden'>
                                <div className='sticky top-0 left-0 bg-white pt-[6px] z-[1]'>
                                    <div className="flex justify-between items-center ">
                                        <div className='flex items-center'> 
                                            <h1 className='text-xl font-normal text-[#000000]'>My Profile</h1>
                                            {
                                                userType !=='super-admin' &&
                                                <span   onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                                                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                                </span> 
                                            }
    

                                        </div>

                                       
                                        <div className='flex items-center gap-3'>
                                            <Link to={'/profile/update-password'} className={`${userType==='super-admin'?'hidden':'min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center text-base font-semibold text-[#972E4C]'}`}>
                                                Update Password
                                            </Link>
                                            {(restrict === true || restrict === 'true') &&
                                            <button id='logout' onClick={() => setLogOutOpen(true)} className={`${userType==='super-admin'?'hidden':'min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center text-base font-semibold text-[#972E4C]'}`}>
                                                Logout
                                            </button>}
                                        </div>
                                    </div>
                                    {userType!=='super-admin' && 

                                    <div className="flex items-center mb-[18px] pt-3.5 pb-1 bg-white">
                                        <p className="text-xl font-semibold text-[#000000]">{data?.userDetails?.first_name || ''} {data?.userDetails?.last_name || ''}</p>
                                        <p className="text-sm font-normal text-[#000000] px-2">{data?.userDetails?.user_id}</p>
                                        {data?.userDetails?.status=='inactive' ? 
                                            <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> : 
                                            <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                        }
                                    </div>
                                    }
                                </div>  
                                {userType!=='super-admin' && 
                                <div>
                                    
                                    <div className=''>
                                        <div className=''>
                                            <div className="bg-[#E7EAF4] rounded-lg p-6">
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Username</p>
                                                            <p data-testid="username" className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.user_name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.email_address!==""?data?.userDetails?.email_address:'-'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p data-testid="phone_number" className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.mobile_number!==""?data?.userDetails?.country_code2+" "+formatMobileNumber(data?.userDetails?.mobile_number):"-"}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                            <p data-testid="main_number" className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.country_code1} {formatMobileNumber(data?.userDetails?.main_number)}</p>
                                                        </div>
                                                    </div>
                                                    {userType==='corporate-user' && 
                                                        <div className="w-2/3 px-1 mb-5">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Address</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {data?.userDetails?.address!==""?data?.userDetails?.address:'-'}</p>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className="w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {date}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Enforce OTP</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.enforceOtp===true ? "True" : "False"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {userType==='corporate-user' && 

                                                <OrganizationAssociatedTouser 
                                                    data={data}
                                                />
                                            }
                                        </div>
                                    </div>

                                </div>
                                }
                               
                                {userType!=='super-admin'&&<div className="">
                                    <div className="mt-3 w-full border border-[#C5C9DA] rounded-sm px-6 pt-[22px] pb-[12px]">
                                        <div className="flex items-center">
                                            <p id="add_otp_preference" className="text-xl font-normal text-[#000000]">Add OTP Preference</p>
                                        </div>
                                        <div className='w-full flex tm:flex-nowrap flex-wrap flex-start'>
                                            <div className='flex items-start mb-[15px] justify-center pt-[23px]'>
                                                <div className='rounded-[16px] border flex border-[#C5C9DA]  py-1 items-center'>
                                                    <p 
                                                        onClick={() =>!verificationLoading && handleOtpPreference("text")}
                                                        id='text'
                                                        className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'text'? 'text-[#972E4C]' : 'text-[#777C88]'}  text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'text'? 'bg-[#E7CBD2] delay-75 transition-all' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] ${verificationLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                                                        Text 
                                                    </p>
                                                    <p 
                                                        onClick={() =>!verificationLoading && handleOtpPreference("voice")}
                                                        id='voice'
                                                        className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'voice'? 'text-[#972E4C]' : 'text-[#777C88]'} text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'voice' ? 'bg-[#E7CBD2] delay-75 transition-all' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] ${verificationLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                                                        Voice
                                                    </p>
                                                    <p 
                                                        onClick={() => !verificationLoading && handleOtpPreference("email")}
                                                        id='email'
                                                        className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'email'? 'text-[#972E4C]' : 'text-[#777C88]'} text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'email' ? 'bg-[#E7CBD2] delay-75 transition-all' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] ${verificationLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                                                        Email 
                                                    </p>
                                                </div>
                                            </div>
                                        
                                            <div className='tn:w-1/3  xl:pl-[41px] pl-[20px] '>
                                                <div className={`w-full mb-[35px]`}>
                                                    <PhoneNumberValidator
                                                        label={"Telephone Number *"}
                                                        placeholder={"Enter Telephone Number"}
                                                        id={"mobile_number"}
                                                        data_testid={"mobile_number"}
                                                        htmlFor={"mobile_number"}
                                                        value={preferences.mobile_number}
                                                        emptyField={false}
                                                        handleOnChangeInput={handleUserInput}
                                                        isCode={true}
                                                        countryCodeList={countryCodes}
                                                        handleCountryCode={handleCountryCode}
                                                        handleSelectCountryCode={handleSelectCountryCode}
                                                        countryCodeVal={countryCodeVal}
                                                        disabled={(preferences.otp_preference_mode === 'email') ? true : false}
                                                        maxLength={30}
                                                        preferences={preferences}
                                                        setCountryCodeVal={setCountryCodeVal}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        isPhoneNumberValid={isPhoneNumberValid.mobile_number}
                                                    
                                                    />
                                                </div>
                                                {phoneNumberError && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438]  '} message={"Invalid telephone number"} />}
                                            </div>
                                    
                                            <div className={`tn:w-1/3 tn:pr-0 pr-[20px]   xl:px-[41px] ${isSideBar ?' pl-[20px]':""} tn:pl-[20px]`}>
                                                <div className={`w-full ${emailError ? 'mb-[15px]' : 'mb-[35px]'}`}>
                                                    <InputBox
                                                        label={"Email Address *"}
                                                        placeholder={"Enter Email Address"}
                                                        id={"email_address"}
                                                        data_testid={"email_address"}
                                                        htmlFor={"email_address"}
                                                        value={preferences.email_address}
                                                        // emptyField={emptyField && preferences?.email_address?.trim() === "" && preferences?.mobile_number?.trim() === ""}
                                                        // emailError={emailError.email_error}
                                                        handleOnChangeInput={handleUserInput}
                                                        disabled={(preferences.otp_preference_mode === 'text' || preferences.otp_preference_mode === 'voice') ? true : false}
                                                        emailError={emailError}
                                                    />
                                                </div>
                                                {emailError && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438]'} message={"Invalid email address"} />}
                                            </div>
                                    
                                            <button
                                                className="mt-[23px] tm:w-[250px] w-[210px] bg-[#972E4C] text-white py-2.5 rounded-[16px] text-lg font-normal h-fit mr-[16px] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]"
                                                id='verification_btn'
                                                disabled={(preferences.mobile_number === '' && preferences.email_address === '') || verificationLoading || !isPhoneNumberValid}
                                                onClick={() => handleVerification()}
                                            >{verificationLoading ? <Loader /> : 'Save Preference'}
                                            </button>
                                        </div>
                                    </div>
                                    {userType!=='super-admin'&&<>
                                        <div className="flex items-center my-[20px]">
                                            <p className="text-xl font-normal text-[#000000]">OTP Preference List</p>
                                        </div>
                                        {emptyScreen ? <Emptyscreenwithouttitle FirstPTag={"No OTP preferences added yet"} /> :
                                            (
                                                preferenceLoader?<CustomOverLay Active text="Loading Preference List..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened_sidebar_overlay2':'overlay-list2'}`}/>:<div className="border border-[#EDD7E1] rounded  overflow-auto scrollBar-hidden mt-3.5 mb-5 pb-2">
                                                    <table aria-label="Outside Table" className="w-full table-auto">
                                                        <thead>
                                                            <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm">
                                                                <th id="id" className="px-3 py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Email Address
                                                                    </span>
                                                                </th>
                                                                <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number
                                                                    </span>
                                                                </th>
                                                                <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">OTP Preference Mode
                                                                    </span>
                                                                </th>
                                                                <th id='action' className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] bg-[#EDD7E1] max-w-[245px] sticky right-0 pl-[92px]">
                                                                    <span className="flex items-center justify-center text-end text-sm font-normal text-[#000000]">Action
                                                                    </span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {preferenceList.map((item,index) => (
                                                                //${selectedPreference._id === item._id ? 'bg-[#F8EEF1]' : 'bg-[#fff]'}
                                                                <tr key={index} className={` hover:bg-[#F8EEF1] h-[45px] table-tr`}>
                                                                    <td className="px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{item.otp_preference_mode === 'email' ? item.preference : '-'}</td>
                                                                    <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{(item.otp_preference_mode === 'text' || item.otp_preference_mode === 'voice') ? item.country_code + ' ' + formatMobileNumber(item.preference) : '-'}</td>    
                                                                    <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{item.otp_preference_mode === 'email' ? "Email" : item.otp_preference_mode === 'text' ? "Text" : "Voice"}</td>    
                                                                    {/* ${selectedPreference._id === item._id ? 'bg-[#F8EEF1]' : 'bg-[#fff]'} */}
                                                                    <td className={`px-8 py-2 text-sm text-end font-normal sticky right-0 max-w-[245px] text-[#031624] rounded-tr-[2px] rounded-br-[2px] min-w-[50px] last-td `}>  
                                                                        <div className="flex justify-center "> 
                                                                            <div onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}} 
                                                                                onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className="px-8  min-w-[200px]">
                                                                                {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation))?<>
                                                                                    <motion.div
                                                                                        initial={{ opacity: 1, x: 0,y:0 }}
                                                                                        animate={{ opacity: 1, x: -45 ,y:0}}
                                                                                        transition={{ delay: 0.2, duration: 0.5 }}
                                                                                        exit={{ opacity: 0.5 }}
                                                                                        className=''
                                                                                    >
                                                                                        <button 
                                                                                            onClick={()=>{openDeleteModal(item)}}
                                                                                                
                                                                                        > 
                                                                                            <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                                                                    </motion.div>                  
                                                                                </>:<button 
                                                                                    onClick={()=>{openDeleteModal(item)}}
                                                                                    id={index+'pref_remove'} 
                                                                                > 
                                                                                    <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}                 
                                                                                {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation)) &&
                                                                                    <motion.div
                                                                                        initial={{ opacity: 0, x: 0,y:0 }}
                                                                                        animate={{ opacity: 1, x: 0 ,y:0}}
                                                                                        transition={{ delay: 0.2, duration: 0.5 }}
                                                                                        exit={{ opacity: 0.5 }}
                                                                                        className=''
                                                                                    >                 
                                                                                        <div className='relative ml-5 cursor-pointer mt-[-25px]' onClick={()=>{openDeleteModal(item)}} >                                   
                                                                                            <p  className="text-sm ml-10  font-normal text-[#972E4C] ">Delete</p>                                 
                                                                                        </div>
                                                                                    </motion.div>                             
                                                                                }                    
                                                                            </div>         
                                                                        </div> 
                                                                    </td>  
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )
                                        }
                                    </>}
                                </div>}
                                
                            </div>
                        </>}
                    </div>

                </>
            }
            
            {deletePreferenceModal && 
                <AnimatedModel key="logout-model"
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleDeletePreferences}
                            handleClose={() => {setDeletePreferenceModal(false), setSelectedPreference({})}}
                            tittle= {`Delete`}
                            disabled={deleteLoading}
                            message={
                                (preferenceList.length === 1 && userType === 'corporate-user')
                                    ? 'You will not be able to access full navigation until you add a new OTP preference and log in again. Are you sure you want to delete this mode of preference?'
                                    : 'Are you sure you want to delete this mode of preference?'
                            }                            buttonName = {`Delete`}
                            loadingActivation={deleteLoading}
                        />
                    }
                />  
            }
            {logOutOpen &&
            <AnimatedModel key="logout-model"
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleLogout}
                        handleClose={() => setLogOutOpen(false)}
                        tittle= {`Logout`}
                        message = {`Are you sure you want to logout?`}
                        buttonName = {`Logout`}
                        disabled={logoutLoading}
                        loadingActivation={logoutLoading}
                    />
                }
            />
            }
            {showOtpLogoutPrompt &&
            <AnimatedModel key="otp-logout-prompt"
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleLogout}
                        handleClose={() => setShowOtpLogoutPrompt(false)}
                        tittle="OTP Preference Added"
                        message="You now need to logout in order to restore full navigation. Please click 'Logout'; however, if you first wish to add more OTP methods, please click 'Cancel' to continue."
                        buttonName="Logout"
                        disabled={logoutLoading}
                        loadingActivation={logoutLoading}
                    />
                }
            />
            }
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
    )
}
